module.exports = __webpack_public_path__ + "img/HA2508-38.bc2a00c9.jpg";